import React from 'react';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import { IoLocationOutline, IoPersonOutline, IoCalendarClearOutline, IoPeopleOutline } from "react-icons/io5";
import { Exercise } from "../../../../models/Exercise";
import getId from "../../../../../utils/getId";
import EAChip from "../../../shared/Chip/EAChip";
import { useTranslation } from "react-i18next";

interface IProps {
  exercise: Exercise;
}

const CompactExerciseInfo: React.FC<IProps> = ({ exercise }) => {
  const { t } = useTranslation();
  const getCompactInfoItem = (icon: React.ReactNode, value: string) => (
    <div className="compact-exercise-info__item">
      {icon}
      <span className="caption text-color-dark">{value}</span>
    </div>
  );

  const trainerName = getId(exercise.deputyHumanIds) ? exercise.deputyHumanName : exercise.humanName;

  // Calculate status chips values
  const totalReserved = exercise.reserved + exercise.prereservation;
  const availableSpots = exercise.capacity - totalReserved;
  const percentageAvailable = exercise.capacity > 0 ? (availableSpots / exercise.capacity) * 100 : 0;
  const hasNoSpaces = availableSpots <= 0;
  const hasLastSpaces = percentageAvailable < 20 && percentageAvailable > 0;

  return (
    <>
      <h5 className="text-color-dark">{exercise.name}</h5>
      {hasNoSpaces && <EAChip label={t("brak_miejsc")} variant="error" />}
      {hasLastSpaces && <EAChip label={t("ostatnie_miejsca")} variant="warning" />}
      <div className="compact-exercise-info">
        <div className="compact-exercise-info__item">
          <IoCalendarClearOutline className="compact-exercise-info__icon" />
          <span className="caption text-color-dark compact-exercise-info__date-value">
            {format(exercise.startTime, "EEEE (dd.MM.yyyy) - HH:mm", { locale: pl })}
          </span>
        </div>
        {getCompactInfoItem(
          <IoLocationOutline className="compact-exercise-info__icon" />,
          exercise.zone?.displayName || "",
        )}
        {trainerName &&
          trainerName.length > 0 &&
          getCompactInfoItem(<IoPersonOutline className="compact-exercise-info__icon" />, trainerName)}
        {getCompactInfoItem(
          <IoPeopleOutline className="compact-exercise-info__icon" />,
          `${exercise.reserved + exercise.prereservation}/${exercise.capacity}`,
        )}
      </div>
    </>
  );
};

export default CompactExerciseInfo;
